import React from "react";
import NullableValue from "../../../Utils/renderField/nullableValue";
import { RenderNumber } from "../../../Utils/renderField/renderReadField";

const ORIGEN_CHIPA_TOLVA = "tolva";

// Formatos con los que los reportes de producción y el historial de tancadas
// muestran sus números, para que las tablas se puedan comparar entre sí
export const RenderKgSecos = ({ value }) => (
    <RenderNumber value={value || 0} decimalScale={2} />
);

export const RenderPorcentaje = ({ value }) => (
    <RenderNumber value={value || 0} decimalScale={2} suffix=" %" />
);

// Celdas de diferencia del comparativo mensual. La fila de tolva no tiene
// diferencia de traslados con qué compararse, así que se quedan en blanco: un
// guion se leería como un dato pendiente. En las otras filas el guion es que no
// hubo traslados en los periodos o que falta guardar una diferencia manual
export const DiferenciaOpcional = ({ fila, campo, children }) =>
    fila.origen_chipa === ORIGEN_CHIPA_TOLVA ? null : (
        <NullableValue value={fila[campo]}>{children}</NullableValue>
    );
